export const THEME_STORAGE_KEY = 'fs.discovery.theme'

export const APP_BACKGROUND_LIGHT = '#fefefe'
export const APP_BACKGROUND_DARK = '#0d0f10'

export const isDarkTheme = () => {
  try {
    const preference = JSON.parse(window.localStorage.getItem(THEME_STORAGE_KEY))
    if (preference === 'dark') return true
    if (preference === 'light') return false
  } catch {
    // Unset or unreadable: fall through to the system setting, which is also what 'system' means.
  }

  try {
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  } catch {
    return false
  }
}

export const getAppBackground = () => (isDarkTheme() ? APP_BACKGROUND_DARK : APP_BACKGROUND_LIGHT)
